import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import toast from "react-hot-toast";
import LottieAnimation from "../../Animations/LottieAnimation";
import TableComponentsCp from "../../Global Functions/tableComponents";
import { columnsFAQ } from "../../Global Functions/columnsAntd";
import { getAllFAQs } from "../../Redux/Actions/faqsAction";

const FAQ = () => {
    const dispatch = useDispatch();

    const { data, loading } = useSelector((state) => state.faq || {});
    const { admin } = useSelector((state) => state.admin || {});

    const accessCode = admin?.data?.access_code || [];
    const canAdd = Array.isArray(accessCode) && accessCode.includes("add");
    const canEdit = Array.isArray(accessCode) && accessCode.includes("edit");

    const [searchQuery, setSearchQuery] = useState("");

    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
    });

    useEffect(() => {
        dispatch(getAllFAQs());
    }, [dispatch]);

    const faqList = useMemo(() => {
        return Array.isArray(data?.data)
            ? data.data.map((item, index) => ({
                key: item?._id || index,
                _id: item?._id,
                created_at: item?.created_at?.split("T")[0] || "N/A",
                question: item?.question || "No Question",
                answer: item?.answer || "No Answer",
            }))
            : [];
    }, [data]);

    const filteredFAQs = useMemo(() => {
        const query = searchQuery.trim().toLowerCase();

        if (!query) return faqList;

        return faqList.filter(
            (item) =>
                item.question?.toLowerCase().includes(query) ||
                item.answer?.toLowerCase().includes(query) ||
                item.created_at?.toLowerCase().includes(query)
        );
    }, [faqList, searchQuery]);

    useEffect(() => {
        setPagination((prev) => ({
            ...prev,
            total: filteredFAQs.length,
        }));
    }, [filteredFAQs]);

    const handleTableChange = (pager) => {
        setPagination(pager);
    };

    const paginatedData = useMemo(() => {
        const start = (pagination.current - 1) * pagination.pageSize;
        const end = start + pagination.pageSize;
        return filteredFAQs.slice(start, end);
    }, [filteredFAQs, pagination.current, pagination.pageSize]);

    if (loading) {
        return <LottieAnimation />;
    }

    return (
        <>
            <TableComponentsCp
                h3heading="FAQ List"
                buttonhead={"Add FAQ"}
                navigateTo={"/faq/addFQ"}
                setState={setSearchQuery}
                pagination={pagination}
                onChange={handleTableChange}
                columns={columnsFAQ(
                    pagination.current,
                    pagination.pageSize,
                    canEdit
                )}
                dataSource={paginatedData}
                loading={loading}
            />
        </>
    );
};

export default FAQ;